import React from 'react';
import { useNavigate } from 'react-router-dom';

const IgnoredForAllVetsPetType: React.FC = () => {
	const navigate = useNavigate();

	return (
		<div className="online-booking-step-container no-one-can-help">
			<h1>Service Availability Update</h1>

			<div className="no-one-can-help__text">
				<p>
					We're sorry, but at this time, we are unable to provide services for your loved one’s species.
				</p>
				<p>
					Please refer to this
					{' '}
					<a href="https://www.vetangel.com/" target="_blank" rel="noopener noreferrer" className="inline-block inline-link">
						directory
					</a>
					{' '}
					for other providers who may be able to assist.
				</p>
			</div>

			<button className="btn btn-primary link" onClick={() => navigate('/')}>
				Return to Home
			</button>
		</div>
	);
};

export default IgnoredForAllVetsPetType;
